<template>
  <div class="panel-middle">
    <div class="flex">
      <h3 class="panel-top-name">{{ title }} </h3>
      <a href="https://github.com/ux-im/doc" target="_blank" class="instruction"><u>{{ $static('ei.instr', 'Інструкція')
          }}</u></a>
    </div>

    <div class="custom-label" v-if="name === 'home'"
      style="color:#565656; margin-top: 20px; font-style: italic;margin-bottom: 15px;">
      {{ $static('te.t222', 'Рекомендований розмір 1200 x 500 px. Крім того, радимо оптимізувати зображення') }}
    </div>

    <div class="files-uploader default-files-uploader" v-if="name === 'home'">
      <div class="files-uploader-holder" v-if="!settings.image || settings.image.length === 0" @click="openFileManager">
        <span class="icon icon-cloud-upload"></span>
        <p>{{ $static('ei.tf1', 'Завантажте свої зображення сюди') }}</p>
        <span>{{ $static('ei.tf2', 'Зображення повинні мати розширення .png або .jpg') }}</span>
      </div>
      <div class="uploader-previews" @click="openFileManager" v-else>
        <div class="image bg" v-for="(image, index) in settings.image"
          :style="{ backgroundImage: 'url(' + image.url + ')' }">
          <a href="javascript:void(0)" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage(index)">
            <span class="icon icon-trash-filled"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, -1)"
            style="bottom: inherit;top: 3px;left: 3px;">
            <span class="icon icon-left"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, 1)"
            style="bottom: inherit;top: 3px;right: 3px;">
            <span class="icon icon-right"></span>
          </a>
        </div>

      </div>
      <div class="image image-placeholder ">
        <div class="text">1200 x 500</div>
      </div>
    </div>


    <div class="row" v-if="template">
      <div class="col">

        <div class="panel panel-bordered">
          <div class="form-group d-flex align-items-center" v-if="template.delay">
            <label class="custom-label w-45 mb-0">Затримка перед показом - рекомендуємо 0 або 5 секунд</label>
            <input type="text" class="form-control custom-input w-20" v-model.number="settings.delay">


            <!--        <div class="form-group" v-if="template.must_confirm">-->
            <!--          <input type="checkbox" v-model="settings.must_confirm">-->
            <!--          <label>Закрити сайт якщо відповідают "Негативна"</label>-->
            <!--        </div>-->

            <!--        <div class="form-group" v-if="template.oneTime">-->
            <!--          <input type="checkbox" v-model="settings.oneTime">-->
            <!--          <label>Відобразити лише перший раз при відкритті сайту.</label>-->
            <!--        </div>-->

          </div>
          <div class="option-line w-45" v-if="template.must_confirm">
            <div class="option-name">Закрити сайт якщо відповідают "Негативна"</div>
            <div class="toggle-holder">
              <div class="toggler r">
                <input type="checkbox" class="toggle-check" v-model="settings.must_confirm">
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div>
          </div>
          <div class="option-line mt-0 w-50" v-if="template.oneTime">
            <div class="option-name">Відобразити лише перший раз при відкритті сайту.</div>
            <div class="toggle-holder">
              <div class="toggler r">
                <input type="checkbox" class="toggle-check" v-model="settings.oneTime">
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="custom-editor-holder custom-pages-editor" v-if="basicLang">
            <textarea v-model="html" class="form-control custom-input">

            </textarea>
          </div>
          <div class="custom-editor-holder custom-pages-editor" v-else>
            <textarea :placeholder="html" v-model="translate.html"
              @update:modelValue="e => setTranslate('html', e)"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-bottom">
    <button class="transparent-btn default-btn back_trigger" @click="$emit('cancel')">
      <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
    </button>
    <button class="default-btn btn-accent" @click="saveTemplate">
      <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
    </button>
  </div>
</template>

<script>
import api from '@/api'
import Editor from './Editor';

export default {
  name: 'PopupEditor',
  components: { Editor },
  emits: ['cancel'],
  props: ['title', 'name', 'lang', 'template'],
  data() {
    return {
      html: '',
      loading: false,
      result: {}
    }
  },
  mounted() {
    this.fetchTemplate(this.name);
    if (this.name === 'home') {
      api.get('/api/options').then(response => response.data).then(data => {
        this.$store.commit('setOptions', data)
      });
    }
  },
  computed: {
    translate: {
      get() {
        return this.lang && this.result.translate && this.result.translate[this.lang] ? this.result.translate[this.lang] : {}
      },
      set(value) {
        // if (this.lang){
        //   this.item.translate[this.lang] = value
        // }
      }
    },
    settings: {
      get() {
        if (!this.result.settings || Array.isArray(this.result.settings)) {
          this.result.settings = {}
        }
        return this.result.settings
      },
      set(value) {
        this.result.settings = value
      }
    },
    basicLang() {
      return this.lang === ''
    },
    categoriesOptions() {
      return this.categories ? this.categories.map(x => { return { label: x.name, value: x.id, url: x.info.url } }) : []
    },
    category: {
      get() {
        return this.categoriesOptions.find(x => x.url == this.settings.url)
      },
      set(value) {
        this.settings.url = value
      }
    },
    options() {
      return this.$store.getters.options
    },
    categories() {
      return this.getOptions('category')
    }
  },
  methods: {
    getOptions(id) {
      let value = this.options.find(i => i.option_id === id);
      if (value) {
        return value.list.sort((a, b) => a.order - b.order)
      }
      return value
    },
    setTranslate(key, value) {
      if (!this.result.translate) {
        this.result.translate = {}
      }
      if (!this.result.translate[this.lang]) {
        this.result.translate[this.lang] = {}
      }
      this.result.translate[this.lang][key] = value
    },

    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    delImage(index) {
      delete this.settings.image.splice(index, 1)
    },
    moveImage(index, target) {
      let n = index + target;
      if (n > -1 && n < this.settings.image.length) {
        [this.settings.image[index], this.settings.image[n]] = [this.settings.image[n], this.settings.image[index]]
      }
    },
    select() {
      // let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      // if (images) {
      //   this.result.settings = Object.assign({}, this.result.settings, {image: images[0]})
      // }
      if (!Array.isArray(this.settings.image)) {
        this.settings.image = []
      }
      let images = this.$store.getters['fm/selectedItems'].map(i => ({ url: encodeURI('/storage/' + i.path) }));
      this.settings.image.push(...images);
    },
    saveTemplate() {
      let obj = Object.assign({}, this.result, { template: this.html, name: this.name });
      api.post('/api/template', obj).then(response => response.data).then(() => {
        // this.template[name] = data;
        this.$emit('cancel');
        this.$notify({
          title: this.$static('notify-page.title', 'Сторінка'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });
      }).catch(error => {
        this.$notify({
          title: this.$static('notify-page.title', 'Сторінка'),
          text: this.$static('notify.save-error', 'Сталася помилка при збереженні.'),
          duration: 3000
        });
      })

    },
    fetchTemplate() {
      this.loading = true;
      api.get('/api/template/' + this.name).then(response => response.data).then(data => {
        this.html = data.template;
        this.loading = false;
        this.result = data;
      }).catch(() => this.loading = false)
    }
  },
  watch: {
    name(name) {
      this.html = '';
      this.fetchTemplate(name);
      if (name === 'home') {
        api.get('/api/options').then(response => response.data).then(data => {
          this.$store.commit('setOptions', data);
        });
      }
    }
  }
}
</script>

<style scoped>
.instruction {
  font-size: 18px;
  display: block;
  margin: 0px 0 15px 0;
}

.custom-pages-editor textarea {
  width: 100%;
  min-height: 600px;
  padding: 10px;
}
</style>